import { cn } from "@/lib/utils";

type IconSize = "sm" | "md" | "lg" | "xl";

const sizes: Record<IconSize, string> = {
  sm: "text-[16px]",
  md: "text-[20px]",
  lg: "text-[24px]",
  xl: "text-[32px]",
};

export function Icon({
  name,
  className,
  size = "md",
  filled,
}: {
  name: string;
  className?: string;
  size?: IconSize;
  filled?: boolean;
}) {
  return (
    <span
      className={cn("material-symbols-outlined", sizes[size], className)}
      style={filled ? { fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24" } : undefined}
      aria-hidden
    >
      {name}
    </span>
  );
}
